/*
    中断理由を選択するリスト
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
export type SuspendReasonProp = {
  // ラベル
  label: string;
  // 中断理由コード
  selectSuspendReasonCode: number;
  // 作業者が選択された場合のイベント処理
  handleSuspendIdChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
};

export const SuspendReasonSelect: React.FC<SuspendReasonProp> = ({
  label,
  selectSuspendReasonCode,
  handleSuspendIdChange,
  disabled,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "suspend-reason-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  const suspensionList = useSelector(
    (state: RootState) => state.suspensionReasons.suspensionReasons
  ); // 中断理由リスト
  const language = useSelector((state: RootState) => state.user.language); // 言語

  // 言語を指定して中断理由一覧を返すユーティリティ
  const createSuspendIdOptions = () => {
    switch (language) {
      case "ja": // 日本語
        return suspensionList.map((elem) => ({
          code: elem.suspension_code,
          reason: elem.suspension_reason.ja,
        }));
      case "en": // 英語
        return suspensionList.map((elem) => ({
          code: elem.suspension_code,
          reason: elem.suspension_reason.en,
        }));
      case "zh": // 中国語
        return suspensionList.map((elem) => ({
          code: elem.suspension_code,
          reason: elem.suspension_reason.zh,
        }));
      case "id": // インドネシア語
        return suspensionList.map((elem) => ({
          code: elem.suspension_code,
          reason: elem.suspension_reason.id,
        }));
      case "vi": // ベトナム語
        return suspensionList.map((elem) => ({
          code: elem.suspension_code,
          reason: elem.suspension_reason.vi,
        }));
    }
  };

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <select
        id={id}
        onChange={handleSuspendIdChange}
        value={selectSuspendReasonCode}
        className="input-180"
        disabled={disabled}
      >
        <option value="">-</option>
        {createSuspendIdOptions().map(({ code, reason }) => (
          <option key={code} value={code}>{`${reason}`}</option>
        ))}
      </select>
    </>
  );
};
